import { TFunction } from 'i18next'
import IBAN from 'iban'
import { z } from 'zod'

import { PaymentMethodsFormSchema } from '../types/paymentMethods/paymentMethodsFormSchema'

export const getPaymentMethodsFormSchema = (t: TFunction): PaymentMethodsFormSchema => {
  return z
    .object({
      bank: z.string(),
      iban: z
        .string()
        .trim()
        .transform((iban) => iban.replace(/\s/g, ''))
        .refine((iban) => !iban || IBAN.isValid(iban), {
          message: t('external_invoices.payment_methods_modal.validation.invalid_iban'),
        }),
      offlinePayment: z.string().trim(),
      paypalEmail: z.string().trim(),
      swift: z.string().refine((swift) => !swift || (swift.length >= 8 && swift.length <= 11), {
        message: t('external_invoices.payment_methods_modal.validation.invalid_swift'),
      }),
    })
    .superRefine(({ bank, swift, iban }, ctx) => {
      const bankFields = [bank, swift, iban].filter(Boolean)

      if (bankFields.length > 0 && bankFields.length < 3) {
        if (!iban) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['iban'],
            message: t('external_invoices.payment_methods_modal.validation.empty_iban'),
          })
        }
      }
    })
}
